<template>
  <div>
    <b-modal
      :model-value="showDialogEdit"
      hide-footer
      centered
      :title="labels.information"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog edit-rol-dialog"
      @hide="closeModal">
      <div class="uniform-modal-body">
        <div class="password-policy-box mb-4">
          <div class="password-policy-title">{{ labels.infoTitle }}</div>
          <div class="password-policy-subtitle">{{ labels.infoText }}</div>
        </div>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.name }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-input 
              v-model="form.nombre" 
              type="text" 
              class="form-input" 
              autocomplete="off"
              placeholder="Nombre del rol"
            ></b-form-input>
          </b-col>
        </b-row>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.description }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-textarea 
              v-model="form.descripcion" 
              rows="3" 
              max-rows="6" 
              class="form-input"
              placeholder="Descripción del rol"
            ></b-form-textarea>
          </b-col>
        </b-row>

        <!-- NUEVO CAMPO: Límite de sesiones -->
        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5 class="form-label">{{ labels.limiteSesiones }}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-input 
              v-model.number="limiteSesiones" 
              type="number" 
              min="1" 
              step="1"
              class="form-input"
              placeholder=" "
              @keypress="soloNumeros"
            ></b-form-input>
          </b-col>
        </b-row>

        <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
          <b-button class="mr-2 reset-btn-secondary" @click="closeModal()">{{ labels.cerrar }}</b-button>
          <b-button class="reset-btn-primary" @click="editInfoRol(form)">{{ labels.guardar }}</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Rol from "@/services/Roles";
export default {
    props: ['showDialogEdit', 'Item'],
    data() {
        return {
            isLoading: false,
            limiteSesiones: null, // vacío por defecto
            form: {
                id: null,
                nombre: '',
                descripcion: ''
            },
        }
    },
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    information: "Editar Rol",
                    name: "Nombre",
                    description: "Descripción",
                    limiteSesiones: "Límite de sesiones simultáneas",
                    guardar: "Guardar",
                    cerrar: "Cerrar",
                    infoTitle: "Datos del rol",
                    infoText: "Actualiza la información y guarda los cambios."
                }
            } else {
                return {
                    information: "Edit Role",
                    name: "Name",
                    description: "Description",
                    limiteSesiones: "Simultaneous session limit",
                    guardar: "Save",
                    cerrar: "Close",
                    infoTitle: "Role information",
                    infoText: "Update the information and save changes."
                }
            }
        }
    },
    watch: {
        Item: {
            immediate: true,
            handler(newValue) {
                const currentItem = newValue || {};
                this.form = {
                    id: currentItem.id || null,
                    nombre: currentItem.nombre || '',
                    descripcion: currentItem.descripcion || ''
                };
                if (currentItem.id) {
                    this.cargarLimiteSesiones(currentItem.id);
                }
            }
        },
        'Item.id': function(newVal) {
            if (newVal) {
                this.cargarLimiteSesiones(newVal);
            }
        },
        showDialogEdit: function(newVal) {
            if (newVal && this.Item && this.Item.id) {
                this.cargarLimiteSesiones(this.Item.id);
            }
        }
    },
    methods: {
        soloNumeros(evt) {
            const charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            }
        },
        async cargarLimiteSesiones(rolId) {
            // Resetear a vacío ANTES de consultar, para evitar mostrar
            // el valor del rol anterior mientras llega la respuesta.
            this.limiteSesiones = null;

            try {
                const res = await Rol.getLimiteSesionesByRol(rolId);
                if (res.data && res.data.limite && res.data.limite.length > 0) {
                    // Ya existe config para este rol → mostrar el valor
                    this.limiteSesiones = res.data.limite[0].limite_sesiones;
                }
                // Si no existe → se queda como null (vacío)
            } catch (error) {
                console.log(error);
                // Si falla la consulta, dejamos vacío
                this.limiteSesiones = null;
            }
        },
        async editInfoRol(Item) {
            if (!Item.nombre) {
                this.$toast.error("Diligenciar el nombre del rol")
                return
            }
            if (!Item.descripcion) {
                this.$toast.error("Diligenciar la descripción del rol")
                return
            }
            if (this.limiteSesiones === null || this.limiteSesiones === "" || this.limiteSesiones < 1) {
                this.$toast.error('El límite de sesiones debe ser al menos 1')
                return
            }

            this.isLoading = true;
            Item.idUser = this.$store.state.userId;

            try {
                await Rol.updateRolById(Item);

                await Rol.updateLimiteSesiones({
                    rol_id: Item.id,
                    limite_sesiones: this.limiteSesiones,
                    idUser: this.$store.state.userId
                });

                this.$toast.success("Rol editado correctamente")
                this.$emit('updated', {
                    id: Item.id,
                    nombre: Item.nombre,
                    descripcion: Item.descripcion
                })
                this.closeModal()
            } catch (error) {
                console.log(error);
                this.$toast.error("No se pudo editar el rol")
            } finally {
                this.isLoading = false;
            }
        },
        closeModal() {
            this.$emit('closeModal', false)
        }
    }
}
</script>